import { GroupRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * updateGroupByCustomerAndDepartment - Function that updates on database an existing group by id   
 * /groups/{id}  
 * method PUT 
 * @async-function
 */
const updateGroupByCustomerAndDepartment = async (token: string, id: number, model: GroupRequestType) => {
    const response = await api.put(
        `/groups/${id}`,{ ...model }, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};

export default updateGroupByCustomerAndDepartment;